import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import SettingsIcon from '@mui/icons-material/Settings';
import PaidIcon from '@mui/icons-material/Paid';
import CallIcon from '@mui/icons-material/Call';

import {
  Grid,
  Typography,
  IconButton,
} from '@mui/material';

import AvatarWithStatus from './AvatarWithStatus';
import { currentContactSelector } from '../nfChatSlice';
import { useGetAppConfigQuery } from 'app/api/mainApi';

import DialogsContext from 'app/contexts/DialogsContext';
import TributeWorkflowContainer from 'app/containers/modals/tributes/TributeWorkflowContainer';

const ContactBarContainer = () => {
  const { openDialog } = useContext(DialogsContext);
  const currentContact = useSelector(currentContactSelector);
  const currentUser = useGetAppConfigQuery().data?.current_user;
  const navigate = useNavigate();

  const onPayTributeClick = (e) => {
    e.preventDefault();

    openDialog({
      component: TributeWorkflowContainer,
      props: { advisorLogin: currentContact?.other_user.name },
    });
  };

  const onCallClick = (e) => {
    e.preventDefault();
    navigate(`/${currentContact?.other_user.id}#live`);
  };

  return (
    <Grid
      className="contact-bar"
      container
      sx={{
        backgroundColor: 'rgb(245, 245, 254)',
        padding: '10px 30px',
        alignItems: 'center',
        marginTop: '12px',
      }}
    >
      <Grid item xs="auto">
        <AvatarWithStatus contact={currentContact} />
      </Grid>
      <Grid item xs>
        <Typography variant="h6" sx={{ paddingLeft: 1.5 }}>
          {currentContact?.other_user.name}
        </Typography>
      </Grid>
      <Grid item xs="auto" sx={{ textAlign: 'right' }}>
        {!currentUser?.is_advisor && (
          <>
            <IconButton onClick={onPayTributeClick}>
              <PaidIcon />
            </IconButton>
            <IconButton onClick={onCallClick}>
              <CallIcon />
            </IconButton>
          </>
        )}
        <IconButton>
          <SettingsIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default ContactBarContainer;
